import CustomImage from './image';

export default CustomImage;